import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { Dividend, DividendType } from '@zero/statistics/domain';

@Pipe({
  name: 'dividendByPeriod',
  standalone: true,
})
export class DividendByPeriodPipe implements PipeTransform {
  private readonly _currencyPipe = inject(CurrencyPipe);

  private readonly dash = '—';

  public transform(value: Dividend, ...args: unknown[]): string {
    if (!value || !args?.length) {
      return this.dash;
    }

    const periods = args[1] && (args[1] as DividendType) === 'forecast' ? value.forecastedPeriods : value.historicalPeriods;
    const dividend = periods?.find(({ period }) => period === args[0]);
    if (dividend?.dividendAbsolute && !isNaN(dividend.dividendAbsolute)) {
      return this._currencyPipe.transform(dividend.dividendAbsolute) + (dividend.selfForecasted ? ' *' : '');
    }
    return this.dash;
  }
}
